import { CALL_API } from '../middleware/api';
import serialize from 'object-to-formdata';

export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const SUCCESS_FETCH_CATEGORIES = "SUCCESS_FETCH_CATEGORIES";
export const FAILURE_FETCH_CATEGORIES = "FAILURE_FETCH_CATEGORIES";

export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const SUCCESS_UPDATE_CATEGORY = "SUCCESS_UPDATE_CATEGORY";
export const FAILURE_UPDATE_CATEGORY = "FAILURE_UPDATE_CATEGORY";
export const CLEAR_UPDATE_CATEGORY = "CLEAR_UPDATE_CATEGORY";

export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const SUCCESS_CREATE_CATEGORY = "SUCCESS_CREATE_CATEGORY";
export const FAILURE_CREATE_CATEGORY = "FAILURE_CREATE_CATEGORY";
export const CLEAR_CREATE_CATEGORY = "CLEAR_CREATE_CATEGORY";

export function fetchCategories() {
    return {
        type: FETCH_CATEGORIES,
        [CALL_API]: {
            endpoint: '/api/services/categories',
            method: 'get',
            types: [SUCCESS_FETCH_CATEGORIES, FAILURE_FETCH_CATEGORIES]
        }
    }
}

export function updateCategory(data) {
    const { Id } = data;
    return {
        type: UPDATE_CATEGORY,
        [CALL_API]: {
            endpoint: `/api/services/categories/${Id}`,
            method: 'post',
            types: [SUCCESS_UPDATE_CATEGORY, FAILURE_UPDATE_CATEGORY],
            data: serialize(data),
            isFormData: true
        }
    }
}

export function createCategory(data) {
    return {
        type: CREATE_CATEGORY,
        [CALL_API]: {
            endpoint: `/api/services/categories`,
            method: 'post',
            types: [SUCCESS_CREATE_CATEGORY, FAILURE_CREATE_CATEGORY],
            data: serialize(data),
            isFormData: true
        }
    }
}

export function clearUpdateCategory() {
    return { type: CLEAR_UPDATE_CATEGORY }
}

export function clearCreateCategory() {
    return { type: CLEAR_CREATE_CATEGORY }
}



// WEBPACK FOOTER //
// ./src/actions/categories.js